import React, { useRef } from 'react';
import CountUp from 'react-countup';
import 'intersection-observer';
import { useIsVisible } from 'react-is-visible';

const Counter = ({
  value = 99999,
  duration = 1.5,
  prefix = '',
  suffix = '',
  decimals = 0,
  decimal = '.',
  separator = ',',
  onEnd = () => null,
  onStart = () => null,
  containerProps = {},
  delay = 0,
  className = '',
}) => {
  const nodeRef = useRef();
  const isVisible = useIsVisible(nodeRef);
  return (
    <div ref={nodeRef} {...containerProps}>
      <CountUp
        start={isVisible}
        end={value}
        duration={duration}
        separator={separator}
        decimals={decimals}
        decimal={decimal}
        prefix={prefix}
        suffix={suffix}
        onEnd={onEnd}
        onStart={onStart}
        delay={delay}
        className={className}
      >
        {({ countUpRef }) => (
          <div>
            <span ref={countUpRef} />
          </div>
        )}
      </CountUp>
    </div>
  );
};

export default Counter;
